import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { assignBadgeToUser, createBadge, createBadgeCategory, deleteBadge, deleteBadgeCategory, getBadgeById, getBadgeCategoryById, getBadgeCategoryList, getBadgeList, updateBadge, updateBadgeCategory } from '../api/badge';

export const useCreateBadgeCategory = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['create-badge-category'],
        mutationFn: (data) => createBadgeCategory(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['badge-categories']);
        },
    });
}

export const useGetBadgeCategoryList = () => {
    return useQuery({
        queryKey: ['badge-categories'],
        queryFn: () => getBadgeCategoryList(),
        refetchOnWindowFocus: false,
    });
}

export const useGetBadgeCategoryDetails = (id) => {
    return useQuery({
        queryKey: ['badge-categories-details', id],
        queryFn: () => getBadgeCategoryById(id),
        enabled: !!id, // Only run the query if id is defined
    });
}

export const useUpdateBadgeCategory = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['update-badge-category'],
        mutationFn: (data) => updateBadgeCategory(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['badge-categories']);
        },
    });
}

export const useDeleteBadgeCategory = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['delete-badge-category'],
        mutationFn: (id) => deleteBadgeCategory(id),
        onSuccess: () => {
            queryClient.invalidateQueries(['badge-categories']);
        },
    });
}

export const useCreateBadge = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationKey: ['create-badge'],
        mutationFn: (data) => createBadge(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['badge-list']);
        },
    })
}

export const useGetBadgeList = () => {
    return useQuery({
        queryKey: ['badge-list'],
        queryFn: () => getBadgeList(),
        refetchOnWindowFocus: false,
    });
}

export const useGetBadgeById = (id) => {
    return useQuery({
        queryKey: ['badge-details', id],
        queryFn: () => getBadgeById(id),
        enabled: !!id,
    });
}

export const useUpdateBadge = () => {
    return useMutation({
        mutationKey: ['update-badge'],
        mutationFn: (data) => updateBadge(data)
    });
}

export const useDeleteBadge = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['delete-badge'],
        mutationFn: (id) => deleteBadge(id),
        onSuccess: () => {
            queryClient.invalidateQueries(['badge-list']);
        },
    });
}

export const useAssignBadgeToUser = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['assign-badge-to-user'],
        mutationFn: (data) => assignBadgeToUser(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['badge-list']);
            queryClient.invalidateQueries(['allUsersByType']);
        },
    });
}
